import { PrescriptionP1HistoryPrescription } from '@dreryk/egabinet-prescription-frontend-api';

import { dateFormatter, Translate } from '@dreryk/react-common';
import {
   IconSize,
   NotesIcon,
   StrongText,
   Text,
   TextSeparator,
   TextSeparatorType,
   Tooltip,
   TooltipPlacement,
} from '@dreryk/react-components';

import { prescriptionsHistoryDownloadTranslationKeys } from '../translations';

import {
   StyledP1PrescriptionIssuedFromCell,
   StyledP1PrescriptionStatusIcon,
   StyledP1PrescriptionStatusTooltipContent,
   StyledP1PrescriptionStatusTooltipTitle,
   StyledP1PrescriptionStatusTooltipTitleIcon,
} from './P1PrescriptionIssuedFromCell.styled';
import { getP1PrescriptionStatusColor, getP1PrescriptionStatusIcon } from './P1PrescriptionsHistoryTable.utils';

type P1PrescriptionIssuedFromCellProps = {
   readonly prescription: PrescriptionP1HistoryPrescription;
};

const tableTranslationKeys = prescriptionsHistoryDownloadTranslationKeys.prescriptionsHistoryView.table;

const renderTooltipContent = (prescription: PrescriptionP1HistoryPrescription): JSX.Element => {
   const statusColor = getP1PrescriptionStatusColor(prescription.status);
   const StatusIcon = getP1PrescriptionStatusIcon(prescription.status);
   const { emptyDate } = tableTranslationKeys.statusTooltip;
   const issuedDate = prescription.issued ? dateFormatter(prescription.issued) : null;
   const issuedFrom = prescription.issuedFrom ? dateFormatter(prescription.issuedFrom) : null;

   return (
      <StyledP1PrescriptionStatusTooltipContent>
         <StyledP1PrescriptionStatusTooltipTitle color={statusColor} data-test-id={'statusTitle'}>
            <StyledP1PrescriptionStatusTooltipTitleIcon>
               <StatusIcon />
            </StyledP1PrescriptionStatusTooltipTitleIcon>
            <Translate>{tableTranslationKeys.status[prescription.status]}</Translate>
         </StyledP1PrescriptionStatusTooltipTitle>
         <TextSeparator separator={TextSeparatorType.COLON_SPACE}>
            <Translate>{tableTranslationKeys.statusTooltip.issuedDate}</Translate>
            <StrongText testId={'issuedDate'}>{issuedDate ?? <Translate>{emptyDate}</Translate>}</StrongText>
         </TextSeparator>
         <TextSeparator separator={TextSeparatorType.COLON_SPACE}>
            <Translate>{tableTranslationKeys.statusTooltip.issuedFrom}</Translate>
            <StrongText testId={'issuedFrom'}>{issuedFrom ?? <Translate>{emptyDate}</Translate>}</StrongText>
         </TextSeparator>
      </StyledP1PrescriptionStatusTooltipContent>
   );
};

export const P1PrescriptionIssuedFromCell = (props: P1PrescriptionIssuedFromCellProps): JSX.Element => {
   const statusColor = getP1PrescriptionStatusColor(props.prescription.status);

   return (
      <StyledP1PrescriptionIssuedFromCell>
         <Text testId={'issuedFrom'}>
            {props.prescription.issuedFrom ? dateFormatter(props.prescription.issuedFrom) : null}
         </Text>
         <Tooltip
            testId={'issuedFromStatus'}
            content={renderTooltipContent(props.prescription)}
            placement={TooltipPlacement.TOP}
         >
            <StyledP1PrescriptionStatusIcon testId={'issuedFromStatusIcon'} size={IconSize.NORMAL} color={statusColor}>
               <NotesIcon />
            </StyledP1PrescriptionStatusIcon>
         </Tooltip>
      </StyledP1PrescriptionIssuedFromCell>
   );
};
